var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "#5F5F5F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2451 58.5651C24.7068 58.5651 24.1684 58.3667 23.7434 57.9417C22.9218 57.1201 22.9218 55.7601 23.7434 54.9384L42.2168 36.4651C43.5768 35.1051 43.5768 32.8951 42.2168 31.5351L23.7434 13.0617C22.9218 12.2401 22.9218 10.8801 23.7434 10.0584C24.5651 9.23672 25.9251 9.23672 26.7468 10.0584L45.2201 28.5317C46.6651 29.9767 47.4868 31.9317 47.4868 34.0001C47.4868 36.0684 46.6934 38.0234 45.2201 39.4684L26.7468 57.9417C26.3218 58.3384 25.7834 58.5651 25.2451 58.5651Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0fde3b54a79542bf58069cc2700325ae.svg";
export { ForwardRef as ReactComponent };